import { useUserContext } from '@hooks/context/useUserContext';
import { EUserStatus } from '@xeppt/xeppt-sdk/types';
import { useKycModals } from '@hooks/modals/useKycModals';

export const useVerificationGuard = () => {
    const { userStatus } = useUserContext();
    const { handleOpenPendingModal, handleOpenSuspendedModal, handleOpenKycFirstModal } =
        useKycModals();

    const verifiedAction = <T = void>(callback?: () => T, unVerifiedCallback?: () => void) => {
        if (userStatus === EUserStatus.PENDING) {
            handleOpenPendingModal();
            unVerifiedCallback && unVerifiedCallback();
        } else if (userStatus !== EUserStatus.UNVERIFIED && userStatus !== EUserStatus.SUSPENDED) {
            return callback && callback();
        } else {
            if (userStatus === EUserStatus.SUSPENDED) {
                handleOpenSuspendedModal();
            } else if (userStatus === EUserStatus.UNVERIFIED) {
                handleOpenKycFirstModal();
            }
            unVerifiedCallback && unVerifiedCallback();
        }
    };

    return {
        verifiedAction
    };
};
